import Flickity from 'flickity';

export default class ShowcaseOverviewLink {
    constructor(container) {
        this.container = container;
        this.list = container.querySelector('.showcase-overview-link-block__list');
        this.leftArrow = container.querySelector('.showcase-overview-link-block__scroll-left');
        this.rightArrow = container.querySelector('.showcase-overview-link-block__scroll-right');

        if (!this.list || !this.leftArrow || !this.rightArrow) return;

        this.mqSmall = window.matchMedia('(max-width: 1450px)');
        this.mqSuperWide = window.matchMedia('(min-width: 2000px)');
        this.handleResponsive = this.handleResponsive.bind(this);
        this.mqSmall.addEventListener?.('change', this.handleResponsive);
        this.mqSuperWide.addEventListener?.('change', this.handleResponsive);

            this.handleResponsive();
        }

        getCardCount() {
            return this.list.querySelectorAll('.showcase-card').length;
        }

    shouldInit() {
        const count = this.getCardCount();
        const isSmall = this.mqSmall.matches;
        const isSuperWide = this.mqSuperWide.matches;
        let decision = (isSmall && count > 1) ||  count > 4;

        return decision;
    }

    handleResponsive() {
        if (this.shouldInit()) {
        this.initCarousel();
        } else {
        this.destroyCarousel();
        }
    }

    initCarousel() {
        if (this.flickity) {
            return;
        }

        this.flickity = new Flickity(this.list, {
            contain: true,
            freeScroll: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            cellSelector: '.showcase-card'
        });

        this.container.setAttribute('data-carousel-loading', 'false');
        this.container.setAttribute('data-carousel-loaded', 'true');
        this.container.classList.remove("no-carousel");

        this.bindArrowEvents();
        this.updateArrowVisibility();
        this.updateAriaHidden();

        this.flickity.on('select', () => {
        this.updateArrowVisibility();
        this.updateAriaHidden();
        });
    }

    destroyCarousel() {
        if (!this.flickity) {
        this.leftArrow.classList.remove('visible');
        this.rightArrow.classList.remove('visible');
        this.container.setAttribute('data-carousel-loaded', 'false');
        this.container.classList.add("no-carousel");
        return;
        }

        this.flickity.destroy();
        this.flickity = null;
        this.container.setAttribute('data-carousel-loaded', 'false');
        this.container.classList.add("no-carousel");

        this.leftArrow.classList.remove('visible');
        this.rightArrow.classList.remove('visible');
    }

    bindArrowEvents() {
        this.leftArrow.addEventListener('click', () => this.flickity?.previous());
        this.rightArrow.addEventListener('click', () => this.flickity?.next());
    }

    updateArrowVisibility() {
        if (!this.flickity) {
            return;
        }

        const total = this.flickity.slides.length;

        if (total <= 1 || this.flickity.options.wrapAround) {
            this.leftArrow.classList.add('visible');
            this.rightArrow.classList.add('visible');
        } else {
            const isFirst = this.flickity.selectedIndex === 0;
            const isLast = this.flickity.selectedIndex === total - 1;

            this.leftArrow.classList.toggle('visible', !isFirst);
            this.rightArrow.classList.toggle('visible', !isLast);
        }
    }

    updateAriaHidden() {
        this.flickity?.cells.forEach(cell => {
            const el = cell.element;
            el?.removeAttribute('aria-hidden');
            el?.querySelectorAll('a, button, input, select, textarea').forEach(el => el.removeAttribute('tabindex'));
        });
    }
}
